import {text_mod_30, } from "../text/Text.js";
export const module30 = {
  title:
    "§30. Пряме й переносне значення слів",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_30, },
    ]
  }
